import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { forgotPasswordAction } from '../../../actionCreators/auth';
import '../../../theme/form-style-label-animation.scss';
import { Form, Field } from 'react-final-form';

class ForgotPassword extends Component {
  static propTypes = {
    forgotpassError: PropTypes.object,
    emailStatus: PropTypes.string,
    registerActions: PropTypes.any,
    showLoginCallback: PropTypes.func,
    hideLogin: PropTypes.func,
    notFromHome: PropTypes.string,
  };

  componentDidUpdate() {
    const { forgotpassError, dontAlert, dataLocale } = this.props;
    if (forgotpassError === null && !dontAlert) {
      alert(dataLocale.AN_EMAIL_HAS_BEEN_SENT);
      this.close();
    }
  }

  close = () => {
    const { hideLogin } = this.props;
    hideLogin();
  };

  forgotPasswordSubmit = value => {
    this.props.forgotPasswordAction({ email: value.forgotemail });
  };
  isValidEmail = value => {
    const {
      dataLocale: { THIS_IS_REQUIRED_FIELD, PLEASE_ENTER_VALID_EMAIL },
    } = this.props;
    let error = null;
    if (!value) {
      error = THIS_IS_REQUIRED_FIELD;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      error = PLEASE_ENTER_VALID_EMAIL;
    } else {
      error = undefined;
    }
    return error;
  };

  render() {
    const { notFromHome, showLoginCallback, emailStatus, forgotpassError, dataLocale } = this.props;
    const {
      BACK_TO_LOGIN,
      SUBMIT,
      NO_CUSTOMER_FOUND,
      PLEASE_ENTER_EMAIL_BELOW,
      PLEASE_ENTER_YOUR_EMAIL,
      RESET_YOUR_PASSWORD,
      RECOVERY_MAIL_HAS_BEEN_SENT,
      AN_ERROR_OCCUR_EMAIL,
      BANNER,
    } = dataLocale;
    this.emailSentMessage = '';
    if (emailStatus === 'sent') {
      this.emailSentMessage = RECOVERY_MAIL_HAS_BEEN_SENT;
    } else if (emailStatus === 'fail') {
      this.emailSentMessage = AN_ERROR_OCCUR_EMAIL;
    }

    const banner =
      notFromHome === 'true' ? (
        <div></div>
      ) : (
        <div className="auth-section_left-col">
          <img
            alt={BANNER}
            className="res-img"
            src="//static.lenskart.com/media/wysiwyg/sign-register/sign-in-offer.jpg"
          />
        </div>
      );

    const backtoLogin =
      notFromHome === 'true' ? (
        <div></div>
      ) : (
        <li className="back-to-login">
          <a
            onClick={() => {
              showLoginCallback();
            }}
          >
            <i aria-hidden="true" className="fa fa-arrow-left"></i> {BACK_TO_LOGIN}
          </a>
        </li>
      );
    return (
      <div className="forgot-password-wrapper">
        {banner}
        <div className="auth-section_right-col">
          <Form
            render={({ handleSubmit, values }) => (
              <form noValidate className="form-SLA" name="for-pass" onSubmit={handleSubmit}>
                <div>
                  <h3>{RESET_YOUR_PASSWORD}</h3>
                  <p className="forgot-content">{PLEASE_ENTER_EMAIL_BELOW}</p>
                </div>
                <ul className="lenskart-tabsup ">
                  <li className="input-filed-col">
                    <Field name="forgotemail" validate={this.isValidEmail}>
                      {({ input, meta }) => (
                        <div
                          className={`form-SLA_field-row ${
                            meta.invalid && meta.touched ? 'form-SLA_field-row_invalid' : ''
                          }`}
                        >
                          <input
                            {...input}
                            autoComplete="email"
                            className={
                              meta.valid || (meta.error && meta.dirty)
                                ? 'form-SLA_field-row_label'
                                : ''
                            }
                            type="email"
                          />
                          <label
                            className={values.forgotemail ? 'active' : ''}
                            htmlFor="forgot_email"
                          >
                            {PLEASE_ENTER_YOUR_EMAIL}
                          </label>
                          {meta.error && meta.touched && (
                            <span className="form-SLA_field-row_error">{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    {forgotpassError && <span className="text-red">{NO_CUSTOMER_FOUND}</span>}
                  </li>
                  {backtoLogin}
                  <div className="buttons">
                    <button className="form-SLA_field-row_submit" name="send3" type="submit">
                      {SUBMIT}
                    </button>
                  </div>
                  <div
                    className={
                      this.emailSentMessage.includes('error')
                        ? 'email-sent-error'
                        : 'email-sent-sucess'
                    }
                  >
                    <p>{this.emailSentMessage}</p>
                  </div>
                </ul>
              </form>
            )}
            onSubmit={this.forgotPasswordSubmit}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    forgotpassError: state.auth.forgotpassError,
    emailStatus: state.auth.emailStatus,
    dataLocale: state.locale,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    forgotPasswordAction: data => dispatch(forgotPasswordAction(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
